export const getOriginUrl = (app: 'lxp') => {
    let origin = window.location.origin

    if (app === 'lxp') {
        if (origin.includes('localhost')) origin = origin.replace('8001', '8000')
        origin = origin.replace('video', 'app')
    }

    return origin
}
